import { Box, Theme, Typography, TypographyVariant } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { CSSProperties } from '@mui/styles';
import linkifyHtml from 'linkify-html';
import DOMPurify from 'dompurify';

const useStyles = makeStyles((theme: Theme) => ({
  richTextWrapper: {
    '& blockquote': {
      padding: theme.spacing(1, 1),
      borderLeft: `3px solid ${theme.palette.secondary.main}`,
      '& p': {
        margin: theme.spacing(0, 0),
      },
    },
    '& ul, & ol': {
      padding: theme.spacing(0, 2.7),
    },
  },
}));

export interface HtmlDisplayProps {
  linkify?: boolean;
  text: string;
  variant?: TypographyVariant;
  whiteSpace?: CSSProperties['whiteSpace'];
}

const HtmlDisplay: React.FC<HtmlDisplayProps> = (props: HtmlDisplayProps) => {
  const classes = useStyles();

  const { linkify = false, text, variant = 'body1', whiteSpace } = props;

  const renderText = () => {
    let formatedText = DOMPurify.sanitize(text);
    if (linkify) {
      formatedText = linkifyHtml(formatedText);
    }

    return formatedText.replace(/href(\s?)=/g, "target='_blank' href=");
  };

  return (
    <Typography
      component="div"
      style={{ whiteSpace, wordBreak: 'break-word' }}
      variant={variant}
    >
      <Box
        className={classes.richTextWrapper}
        dangerouslySetInnerHTML={{
          __html: renderText(),
        }}
      />
    </Typography>
  );
};

export default HtmlDisplay;
